import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Legal from './views/Legal.vue';
import Export from './views/Export.vue';
import {Role} from '@/_helpers/role';
import userService from '@/_services/user.service';
import Login from '@/views/Login.vue';

Vue.use(Router);

export const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
        },
        {
            path: '/legal',
            name: 'legal',
            component: Legal,
        },
        {
            path: '/export',
            name: 'export',
            component: Export,
            meta: {
                authorize: [Role.User],
            },
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
        },
    ],
});

router.beforeEach((to, from, next) => {
    const {authorize} = to.meta;
    const currentUser = userService.currentUserValue;

    if (authorize) {
        if (!currentUser) {
            return next({
                path: '/login',
                query: {
                    returnUrl: to.path,
                },
            });
        }

        if (authorize.length && !authorize.includes(currentUser.role)) {
            return next({
                path: '/',
            });
        }
    }

    next();
});

export default router;
